import { render } from "./MemberTitle.vue?vue&type=template&id=dd1d1a06"
import script from "./MemberTitle.vue?vue&type=script&lang=js"
export * from "./MemberTitle.vue?vue&type=script&lang=js"

import "./MemberTitle.vue?vue&type=style&index=0&id=dd1d1a06&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__